import React from 'react';
import ReactPlayer from 'react-player';

import styles from './tutorial.module.scss';
import '../../theme/global.scss';
import { Space } from '../../components/utils/utils';
import { variables } from '../../utils/variables';
import { useGetCurrentUserQuery } from '../../api';

const Tutorial = () => {
  const { data: user } = useGetCurrentUserQuery();

  return (
    <section className={styles.containerTutorial}>
      <div className={styles.steps}>
        <p className='heading-light bold'>
          Instructiuni de utilizare a platformei Sirar
        </p>
        <Space vertical={variables.verticalSpace} />
        <Space vertical={variables.verticalSpace} />
        <p className='subheading-light bold'>
          Mai jos puteti gasi cateva recomandari de utilizare a platformei, iar
          in partea de jos a paginii un tutorial de utilizare sub forma video.
        </p>
        <Space vertical={variables.verticalSpace} />
        <ul>
          {!user?.institution.private && (
            <li className='body-light'>
              Vă încurajăm să completați toate informațiile instituției,
              activitate pe care o puteți face accesând pagină dedicată
              instutiei. (Administrare internă - Instituție)
            </li>
          )}
          <Space vertical={variables.verticalSpace} />
          <li className='body-light'>
            Puteți adaugă un număr limitat de utilizatori, în funcție de
            contractul dumneavoastră.
          </li>
          <Space vertical={variables.verticalSpace} />
          <li className='body-light'>
            Pentru mai multe informații va rugam să consultați&nbsp;
            <a
              href={
                user?.institution.private
                  ? '/Manual de utilizare privat_FINAL.pdf'
                  : '/Manual de utilizare public_FINAL.pdf'
              }
              className={styles.tutorialLink}
              target='_blank'
              rel='noreferrer'
            >
              manualul de utilizare
            </a>
          </li>
        </ul>
      </div>
      {false && (
        <div className={styles.demo}>
          <ReactPlayer url='https://www.youtube.com/watch?v=hydrbPu-XJM' />
        </div>
      )}
      <div className={styles.decoration}></div>
    </section>
  );
};

export default Tutorial;
